export type ContestPhase = 'before-start' | 'active' | 'ended' | 'winner';

export interface ContestStatus {
  configAvailable: boolean;
  tabVisible: boolean;
  contestActive: boolean;
  contestPhase: ContestPhase;
  contestStart: string;
  contestEnd: string;
  entriesEarned: number;
  maxPossibleEntries: number;
  todayEntryEarned: boolean;
  providerTimezone: string | null;
  disclaimerMessage: string | null;
  contestDetailsURL: string | null;
  termsAndConditionsURL: string | null;
}

export const DEFAULT_CONTEST_STATUS: ContestStatus = {
  configAvailable: false,
  tabVisible: false,
  contestActive: false,
  contestPhase: 'before-start',
  contestStart: '',
  contestEnd: '',
  entriesEarned: 0,
  maxPossibleEntries: 0,
  todayEntryEarned: false,
  providerTimezone: null,
  disclaimerMessage: null,
  contestDetailsURL: null,
  termsAndConditionsURL: null,
};
